import HeaderBrand from './HeaderBrand';
export default HeaderBrand;